import { useState, useEffect } from 'react'
import useSWR from 'swr'
import { api } from '@/api'

export default function AdminSettings() {
  const { data, mutate } = useSWR('/settings', () => api.settings.getAll())
  const settings = data?.data || {}

  const [localSettings, setLocalSettings] = useState({
    shop_name: '',
    shop_phone: '',
    shop_address: '',
    business_hours: '',
  })

  const [saving, setSaving] = useState<string | null>(null)
  const [saveSuccess, setSaveSuccess] = useState<string | null>(null)

  useEffect(() => {
    if (settings && Object.keys(settings).length > 0) {
      setLocalSettings(settings)
    }
  }, [settings])

  const handleChange = (key: string, value: string) => {
    setLocalSettings({ ...localSettings, [key]: value })
  }

  const handleSave = async (key: string) => {
    setSaving(key)
    setSaveSuccess(null)
    try {
      await api.settings.update(key, localSettings[key])
      mutate()
      setSaveSuccess(key)
      setTimeout(() => setSaveSuccess(null), 2000)
    } catch (err: any) {
      alert('保存失败：' + err.message)
    } finally {
      setSaving(null)
    }
  }

  const settingFields = [
    { key: 'shop_name', label: '店铺名称', type: 'text', placeholder: '例如：美丽美容院' },
    { key: 'shop_phone', label: '联系电话', type: 'tel', placeholder: '例如：400-888-8888' },
    { key: 'shop_address', label: '店铺地址', type: 'text', placeholder: '例如：北京市朝阳区 XX 路 XX 号' },
    { key: 'business_hours', label: '营业时间', type: 'text', placeholder: '例如：09:00-21:00' },
  ]

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-4">系统设置</h2>

      <div className="space-y-4">
        <div className="card">
          <h3 className="font-semibold text-gray-900 mb-4">基础设置</h3>
          {settingFields.map(field => (
            <div key={field.key} className="mb-4 last:mb-0">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {field.label}
              </label>
              <div className="flex gap-2">
                <input
                  type={field.type}
                  value={localSettings[field.key] || ''}
                  onChange={e => handleChange(field.key, e.target.value)}
                  className="input flex-1"
                  placeholder={field.placeholder}
                />
                <button
                  onClick={() => handleSave(field.key)}
                  disabled={saving === field.key}
                  className="btn-primary py-3 px-4 min-w-[80px]"
                >
                  {saving === field.key ? '保存中...' : '保存'}
                </button>
              </div>
              {saveSuccess === field.key && (
                <p className="text-sm text-green-600 mt-2">✓ 保存成功</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
